// Decodes
// "HUL%C2%A4102" -> "["HUL¤102"]"
export function decodeParam(param) {
  if (!param) return null;
  return param.split(encodeURIComponent(",")).map(p => decodeURIComponent(p));
}
